/**
 * VERSIONE LIBRERIA 3
 */
var RenderCustom = Render.extend({
    type : 'custom',
    classData : 'custom',
    classTemplate : 'custom',
    html : null,
    _renderEdit : function (jQe) {
    },
    _renderView : function (jQe) {
    },
    _renderSearch : function (jQe) {
    },
    _finalizeEdit : function(){
        this._customRender();
    },
    _finalizeView : function() {
        this._customRender();
    },
    _finalizeSearch : function () {
        this._customRender();
    },
    _customRender : function () {
        var self = this;
        if (self.html) {
            if (_.isFunction(self.html)) {
                $(self.container).html(self.html.apply(self));
            } else {
                $(self.container).html(self.html);
            }

        }
    },
    getValue : function () {
        return $(this.container).html();
    },
    setValue : function(value) {
        $(this.container).html(value);
    }
});